// // import React, { useEffect, useRef, useCallback, useState } from 'react';
// // import { useLocation } from "react-router-dom";
// // import Homepage from './Homepage';
// // import FloatingNote from './Floatingnote';

// // function useQuery() {
// //   return new URLSearchParams(useLocation().search);
// // }

// // const MainDashBoard = ({ userDetails, onLogout }) => {
// //     const socketRef = useRef(null);
// //     const inactivityTimerRef = useRef(null);
// //     const lastStatusRef = useRef(null);
// //     const INACTIVITY_LIMIT = 60000;
// //     const [connectionStatus, setConnectionStatus] = useState("Inactive");
// //     const [permissionRequested, setPermissionRequested] = useState(false);
// //     const [selectedLeadId, setSelectedLeadId] = useState(null);
// //     const userId = userDetails?.userId || userDetails?.id || 'unknown';
// //     const userFirstName = userDetails?.firstName || 'Unknown';
// //     const query = useQuery();
// //     const accessToken = localStorage.getItem('accessToken');
// //     useEffect(() => {
// //     const leadId = query.get('leadId');
// //     const callNumber = query.get('call');

// //     if (leadId) {
// //         setSelectedLeadId(leadId);
// //         console.log("✅ Lead ID set from notification:", leadId);
// //     }

// //     if (callNumber) {
// //         console.log("📞 Initiating call to:", callNumber);
// //         window.location.href = `tel:${callNumber}`;
// //     }
// //     }, [query]);

// //     useEffect(() => {
// //         if ('serviceWorker' in navigator) {
// //             navigator.serviceWorker.addEventListener('message', (event) => {
// //             console.log("📩 Message from service worker:", event.data);
// //             const { action, leadId, phoneNumber, tag } = event.data; // Added tag for closing notification

// //             if (leadId) {
// //                 setSelectedLeadId(leadId);
// //                 console.log("✅ Lead ID set from service worker message:", leadId);
// //             }

// //             if (action === 'open-lead-call' && phoneNumber) {
// //                 console.log("📞 Initiating call from service worker message:", phoneNumber);
// //                 window.location.href = `tel:${phoneNumber}`;
// //                 // Close the original notification after action
// //                 if (navigator.serviceWorker.controller) {
// //                     navigator.serviceWorker.controller.postMessage({
// //                         type: 'closeNotification',
// //                         tag: tag
// //                     });
// //                 }
// //             }

// //             if (action === 'copy-phone' && phoneNumber) {
// //                 navigator.clipboard.writeText(phoneNumber).then(() => {
// //                     console.log('Phone number copied to clipboard');
// //                     // Close the original notification after action (removes the button)
// //                     if (navigator.serviceWorker.controller) {
// //                         navigator.serviceWorker.controller.postMessage({
// //                             type: 'closeNotification',
// //                             tag: tag
// //                         });
// //                     }
// //                 }).catch(err => {
// //                     console.error('Failed to copy phone number:', err);
// //                     // Optionally handle error feedback here, e.g., a brief UI toast if available
// //                 });
// //             }
// //             });
// //         }
// //         }, []);

// //     const requestNotificationPermission = useCallback(() => {
// //         if (!("Notification" in window)) {
// //             console.warn("This browser does not support desktop notifications.");
// //             return false;
// //         }
// //         console.log("Current Notification permission:", Notification.permission);
// //         if (Notification.permission !== "granted" && Notification.permission !== "denied") {
// //             Notification.requestPermission().then(permission => {
// //                 console.log("Notification permission result:", permission);
// //                 if (permission === "granted") {
// //                     console.log("Notification permission granted.");
// //                     new Notification("Permission Granted", { body: "Notifications are now enabled!" });
// //                 } else {
// //                     console.warn("Notification permission denied.");
// //                 }
// //                 setPermissionRequested(true);
// //             });
// //             return true;
// //         }
// //         return Notification.permission === "granted";
// //     }, []);

// //     const showNotification = useCallback((title, data, useAlternateIcon = false) => {
// //         if (Notification.permission === "granted") {
// //             navigator.serviceWorker.getRegistration().then(registration => {
// //                 if (registration) {
// //                     const phoneNumber = data.phoneNumber || 'N/A';
// //                     const body = data.customerName 
// //                         ? `Customer: ${data.customerName}\nACVL Lead ID: ${data.LeadACVLRecordID || 'N/A'}\nLead Source: ${data.leadSource || 'N/A'}\nMove Date: ${data.moveDate || 'N/A'}\n\nClick notification to open lead`
// //                         : JSON.stringify(data, null, 2);

// //                     const iconUrl = useAlternateIcon 
// //                         ? 'https://cdn-icons-png.flaticon.com/512/5995/5995339.png'
// //                         : 'https://thumbs.dreamstime.com/z/phone-call-icon-white-phone-call-icon-green-background-100048734.jpg?ct=jpeg';

// //                     // Define actions: only two buttons for copy and call; default click opens lead
// //                     const allActions = [
// //                         { action: 'copy-phone', title: 'Copy Ph.No' },
// //                         { action: 'open-lead-call', title: 'Lead&Call' }
// //                     ];

// //                     // Dynamically limit actions based on browser support
// //                     let displayActions = allActions;
// //                     if ('maxActions' in Notification) {
// //                         const max = Notification.maxActions;
// //                         console.log(`Browser supports max ${max} notification actions`);
// //                         displayActions = allActions.slice(0, max);
// //                     } else {
// //                         // Fallback for older browsers, limit to 2 (but we have only 2)
// //                         displayActions = allActions.slice(0, 2);
// //                         console.log('Using fallback: max 2 notification actions');
// //                     }

// //                     const notificationTag = `message-${Date.now()}`;

// //                     registration.showNotification(title, {
// //                         body,
// //                         icon: iconUrl,
// //                         requireInteraction: true,
// //                         tag: notificationTag,
// //                         actions: displayActions,
// //                         data: {
// //                             LeadACVLRecordID: data.LeadACVLRecordID,
// //                             phoneNumber
// //                         }
// //                     });

// //                     // Note: Pass this tag to service worker if needed for other handling
// //                 } else {
// //                     console.warn("No service worker registration found.");
// //                 }
// //             });
// //         } else {
// //             console.warn("Cannot show notification: Permission not granted.");
// //             alert("Notifications are not enabled. Please allow notifications in your browser settings.");
// //         }
// //     }, []);

// //     const connectWebSocket = useCallback(() => {
// //         if (socketRef.current && socketRef.current.readyState !== WebSocket.CLOSED) return;
// //         socketRef.current = new WebSocket(`ws://localhost:8080?userId=${userId}`);
// //         // socketRef.current = new WebSocket(`wss://websocket-server-130173255555.us-central1.run.app?userId=${userId}`);
// //         // socketRef.current = new WebSocket(`https://websocketserver-3ws0.onrender.com?userId=${userId}`);

// //         socketRef.current.onopen = () => {
// //             console.log("WebSocket connected");
// //             sendToServer("Active");
// //             setConnectionStatus("Active");
// //             resetInactivityTimer();
// //         };

// //         socketRef.current.onmessage = (event) => {
// //             try {
// //                 const message = event.data;
// //                 if (message.includes("Data received:")) {
// //                     console.log("Processing 'Data received' message");
// //                     const dataStr = message.split("Data received: ")[1];
// //                     const data = JSON.parse(dataStr);
// //                     showNotification(`New Lead Notification for ${userId}`, data);
// //                 } else if (message.includes("You sent to")) {
// //                     console.log("Processing 'You sent' message");
// //                     const sentMessage = JSON.parse(message.split("You sent -> ")[1]);
// //                     const status = sentMessage.Userstatus;
// //                     if (status && lastStatusRef.current !== status) {
// //                         lastStatusRef.current = status;
// //                     }
// //                 } else {
// //                     // console.log("General message:", message);
// //                 }
// //             } catch (error) {
// //                 console.error("Error parsing server message:", error);
// //             }
// //         };

// //         socketRef.current.onclose = () => {
// //             console.log("WebSocket disconnected, attempting to reconnect...");
// //             setConnectionStatus("Inactive");
// //             setTimeout(connectWebSocket, 5000); 
// //         };

// //         socketRef.current.onerror = (err) => {
// //             console.error("WebSocket error:", err);
// //             setConnectionStatus("Inactive");
// //         };
// //     }, [userId]);
// //     // const connectWebSocket = useCallback(() => {
// //     //     if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) return;
// //     //      socketRef.current = new WebSocket(`ws://localhost:8080?userId=${userId}`);
// //     //     // socketRef.current = new WebSocket(`wss://websocket-server-130173255555.us-central1.run.app?userId=${userId}`);
// //     //     // socketRef.current = new WebSocket(`https://websocketserver-3ws0.onrender.com?userId=${userId}`);

// //     //     socketRef.current.onopen = () => {
// //     //         console.log("WebSocket connected");
// //     //         sendToServer("Active");
// //     //         setConnectionStatus("Active");
// //     //         resetInactivityTimer();
// //     //     };

// //     //     socketRef.current.onmessage = (event) => {
// //     //         try {
// //     //             const message = event.data;
// //     //             if (message.includes("Data received:")) {
// //     //                 console.log("Processing 'Data received' message");
// //     //                 const dataStr = message.split("Data received: ")[1];
// //     //                 const data = JSON.parse(dataStr);
// //     //                 showNotification(`New Lead Notification for ${userId}`, data);
// //     //             } else if (message.includes("You sent to")) {
// //     //                 console.log("Processing 'You sent' message");
// //     //                 const sentMessage = JSON.parse(message.split("You sent -> ")[1]);
// //     //                 const status = sentMessage.Userstatus;
// //     //                 if (status && lastStatusRef.current !== status) {
// //     //                     lastStatusRef.current = status;
// //     //                 }
// //     //             } else {
// //     //                 // console.log("General message:", message);
// //     //             }
// //     //         } catch (error) {
// //     //             console.error("Error parsing server message:", error);
// //     //         }
// //     //     };

// //     //     socketRef.current.onclose = () => {
// //     //         console.log("WebSocket disconnected, attempting to reconnect...");
// //     //         setConnectionStatus("Inactive");
// //     //         setTimeout(connectWebSocket, 5000); 
// //     //     };

// //     //     socketRef.current.onerror = (err) => {
// //     //         console.error("WebSocket error:", err);
// //     //         setConnectionStatus("Inactive");
// //     //     };
// //     // }, [userId]);

// //     const sendToServer = useCallback((Userstatus) => {
// //         const payload = JSON.stringify({
// //             userId,
// //             UserFirstName: userFirstName,
// //             Userstatus,
// //             accessToken,
// //             timestamp: new Date().toISOString(),
// //         });
// //         if (socketRef.current?.readyState === WebSocket.OPEN) {
// //             socketRef.current.send(payload);
// //             console.log(`Sent ${Userstatus} status to server`);
// //         }
// //     }, [userId, accessToken, userFirstName]);

// //     const resetInactivityTimer = useCallback(() => {
// //         clearTimeout(inactivityTimerRef.current);
// //         inactivityTimerRef.current = setTimeout(() => {
// //             console.log("User inactive. Sending Inactive status...");
// //             sendToServer("Inactive");
// //             setConnectionStatus("Inactive");
// //         }, INACTIVITY_LIMIT);
// //     }, [sendToServer]);

// //     const handleActivity = useCallback(() => {
// //         if (!socketRef.current || socketRef.current.readyState === WebSocket.CLOSED) {
// //             connectWebSocket();
// //         }
// //         if (connectionStatus === "Inactive") {
// //             sendToServer("Active");
// //             setConnectionStatus("Active");
// //         }
// //         resetInactivityTimer();
// //     }, [connectionStatus, connectWebSocket, sendToServer, resetInactivityTimer]);

// //     const handleLogout = useCallback(() => {
// //         sendToServer("Inactive");
// //         if (socketRef.current) {
// //             socketRef.current.close();
// //             console.log("WebSocket closed due to logout");
// //         }
// //         onLogout?.(); 
// //     }, [sendToServer, onLogout]);

// //     useEffect(() => {
// //         requestNotificationPermission();
// //         connectWebSocket();

// //         const events = ["mousemove", "keydown", "mousedown", "touchstart"];
// //         events.forEach((evt) => document.addEventListener(evt, handleActivity));

// //         const handleBeforeUnload = () => {
// //             sendToServer("Inactive");
// //             if (socketRef.current) {
// //                 socketRef.current.close();
// //             }
// //         };

// //         window.addEventListener("beforeunload", handleBeforeUnload);

// //         return () => {
// //             clearTimeout(inactivityTimerRef.current);
// //             events.forEach((evt) => document.removeEventListener(evt, handleActivity));
// //             window.removeEventListener("beforeunload", handleBeforeUnload);
// //         };
// //     }, [handleActivity, requestNotificationPermission, connectWebSocket, sendToServer]);

// //     return (
// //         <>
// //             <Homepage 
// //                 userDetails={userDetails} 
// //                 accessToken={accessToken} 
// //                 connectionStatus={connectionStatus}
// //                 selectedLeadId={selectedLeadId} 
// //                 onLogout={handleLogout}
// //             />
// //             <FloatingNote userDetails={userDetails} accessToken={accessToken} />
// //         </>
// //     );
// // };

// // export default MainDashBoard;
//         // socketRef.current = new WebSocket(`wss://websocket-server-130173255555.us-central1.run.app?userId=${userId}`);
//         // socketRef.current = new WebSocket(`https://websocketserver-3ws0.onrender.com?userId=${userId}`);
// // // before the change in the connection

// import React, { useEffect, useRef, useCallback, useState } from 'react';
// import { useLocation } from "react-router-dom";
// import Homepage from './Homepage';
// import FloatingNote from './Floatingnote';

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

// const MainDashBoard = ({ userDetails, onLogout }) => {
//     const socketRef = useRef(null);
//     const inactivityTimerRef = useRef(null);
//     const lastStatusRef = useRef(null);
//     const INACTIVITY_LIMIT = 60000;
//     const [connectionStatus, setConnectionStatus] = useState("Inactive");
//     const [permissionRequested, setPermissionRequested] = useState(false);
//     const [selectedLeadId, setSelectedLeadId] = useState(null);
//     const userId = userDetails?.userId || userDetails?.id || 'unknown';
//     const userFirstName = userDetails?.firstName || 'Unknown';
//     const query = useQuery();
//     const accessToken = localStorage.getItem('accessToken');
//     useEffect(() => {
//     const leadId = query.get('leadId');
//     const callNumber = query.get('call');

//     if (leadId) {
//         setSelectedLeadId(leadId);
//         console.log("✅ Lead ID set from notification:", leadId);
//     }

//     if (callNumber) {
//         console.log("📞 Initiating call to:", callNumber);
//         window.location.href = `tel:${callNumber}`;
//     }
//     }, [query]);

//     useEffect(() => {
//         if ('serviceWorker' in navigator) {
//             navigator.serviceWorker.addEventListener('message', (event) => {
//             console.log("📩 Message from service worker:", event.data);
//             const { action, leadId, phoneNumber, tag } = event.data; // Added tag for closing notification

//             if (leadId) {
//                 setSelectedLeadId(leadId);
//                 console.log("✅ Lead ID set from service worker message:", leadId);
//             }

//             if (action === 'open-lead-call' && phoneNumber) {
//                 console.log("📞 Initiating call from service worker message:", phoneNumber);
//                 window.location.href = `tel:${phoneNumber}`;
//                 // Close the original notification after action
//                 if (navigator.serviceWorker.controller) {
//                     navigator.serviceWorker.controller.postMessage({
//                         type: 'closeNotification',
//                         tag: tag
//                     });
//                 }
//             }

//             if (action === 'copy-phone' && phoneNumber) {
//                 navigator.clipboard.writeText(phoneNumber).then(() => {
//                     console.log('Phone number copied to clipboard');
//                     // Close the original notification after action (removes the button)
//                     if (navigator.serviceWorker.controller) {
//                         navigator.serviceWorker.controller.postMessage({
//                             type: 'closeNotification',
//                             tag: tag
//                         });
//                     }
//                 }).catch(err => {
//                     console.error('Failed to copy phone number:', err);
//                     // Optionally handle error feedback here, e.g., a brief UI toast if available
//                 });
//             }
//             });
//         }
//         }, []);

//     const requestNotificationPermission = useCallback(() => {
//         if (!("Notification" in window)) {
//             console.warn("This browser does not support desktop notifications.");
//             return false;
//         }
//         console.log("Current Notification permission:", Notification.permission);
//         if (Notification.permission !== "granted" && Notification.permission !== "denied") {
//             Notification.requestPermission().then(permission => {
//                 console.log("Notification permission result:", permission);
//                 if (permission === "granted") {
//                     console.log("Notification permission granted.");
//                     new Notification("Permission Granted", { body: "Notifications are now enabled!" });
//                 } else {
//                     console.warn("Notification permission denied.");
//                 }
//                 setPermissionRequested(true);
//             });
//             return true;
//         }
//         return Notification.permission === "granted";
//     }, []);

//     const showNotification = useCallback((title, data, useAlternateIcon = false) => {
//         if (Notification.permission === "granted") {
//             navigator.serviceWorker.getRegistration().then(registration => {
//                 if (registration) {
//                     const phoneNumber = data.phoneNumber || 'N/A';
//                     const body = data.customerName 
//                         ? `Customer: ${data.customerName}\nACVL Lead ID: ${data.LeadACVLRecordID || 'N/A'}\nLead Source: ${data.leadSource || 'N/A'}\nMove Date: ${data.moveDate || 'N/A'}\n\nClick notification to open lead`
//                         : JSON.stringify(data, null, 2);

//                     const iconUrl = useAlternateIcon 
//                         ? 'https://cdn-icons-png.flaticon.com/512/5995/5995339.png'
//                         : 'https://thumbs.dreamstime.com/z/phone-call-icon-white-phone-call-icon-green-background-100048734.jpg?ct=jpeg';

//                     // Define actions: only two buttons for copy and call; default click opens lead
//                     const allActions = [
//                         { action: 'copy-phone', title: 'Copy Ph.No' },
//                         { action: 'open-lead-call', title: 'Lead&Call' }
//                     ];

//                     // Dynamically limit actions based on browser support
//                     let displayActions = allActions;
//                     if ('maxActions' in Notification) {
//                         const max = Notification.maxActions;
//                         console.log(`Browser supports max ${max} notification actions`);
//                         displayActions = allActions.slice(0, max);
//                     } else {
//                         // Fallback for older browsers, limit to 2 (but we have only 2)
//                         displayActions = allActions.slice(0, 2);
//                         console.log('Using fallback: max 2 notification actions');
//                     }

//                     const notificationTag = `message-${Date.now()}`;

//                     registration.showNotification(title, {
//                         body,
//                         icon: iconUrl,
//                         requireInteraction: true,
//                         tag: notificationTag,
//                         actions: displayActions,
//                         data: {
//                             LeadACVLRecordID: data.LeadACVLRecordID,
//                             phoneNumber
//                         }
//                     });

//                     // Note: Pass this tag to service worker if needed for other handling
//                 } else {
//                     console.warn("No service worker registration found.");
//                 }
//             });
//         } else {
//             console.warn("Cannot show notification: Permission not granted.");
//             alert("Notifications are not enabled. Please allow notifications in your browser settings.");
//         }
//     }, []);

//     const connectWebSocket = useCallback(() => {
//         if (socketRef.current && socketRef.current.readyState !== WebSocket.CLOSED) return;
//         socketRef.current = new WebSocket(`ws://localhost:8080?userId=${userId}`);


//         socketRef.current.onopen = () => {
//             console.log("WebSocket connected");
//             sendToServer("Active");
//             setConnectionStatus("Active");
//             resetInactivityTimer();
//         };

//         socketRef.current.onmessage = (event) => {
//             try {
//                 const message = event.data;
//                 if (message.includes("Data received:")) {
//                     console.log("Processing 'Data received' message");
//                     const dataStr = message.split("Data received: ")[1];
//                     const data = JSON.parse(dataStr);
//                     showNotification(`New Lead Notification for ${userId}`, data);
//                 } else if (message.includes("You sent to")) {
//                     console.log("Processing 'You sent' message");
//                     const sentMessage = JSON.parse(message.split("You sent -> ")[1]);
//                     const status = sentMessage.Userstatus;
//                     if (status && lastStatusRef.current !== status) {
//                         lastStatusRef.current = status;
//                     }
//                 } else {
//                     // console.log("General message:", message);
//                 }
//             } catch (error) {
//                 console.error("Error parsing server message:", error);
//             }
//         };

//         socketRef.current.onclose = () => {
//             console.log("WebSocket disconnected, attempting to reconnect...");
//             setConnectionStatus("Inactive");
//             setTimeout(connectWebSocket, 5000); 
//         };

//         socketRef.current.onerror = (err) => {
//             console.error("WebSocket error:", err);
//             setConnectionStatus("Inactive");
//         };
//     }, [userId]);

//     const sendToServer = useCallback((Userstatus) => {
//         const payload = JSON.stringify({
//             userId,
//             UserFirstName: userFirstName,
//             Userstatus,
//             accessToken,
//             timestamp: new Date().toISOString(),
//         });
//         if (socketRef.current?.readyState === WebSocket.OPEN) {
//             socketRef.current.send(payload);
//             console.log(`Sent ${Userstatus} status to server`);
//         }
//     }, [userId, accessToken, userFirstName]);

//     const resetInactivityTimer = useCallback(() => {
//         clearTimeout(inactivityTimerRef.current);
//         inactivityTimerRef.current = setTimeout(() => {
//             console.log("User inactive. Sending Inactive status...");
//             sendToServer("Inactive");
//             setConnectionStatus("Inactive");
//         }, INACTIVITY_LIMIT);
//     }, [sendToServer]);

//     const handleActivity = useCallback(() => {
//         if (!socketRef.current || socketRef.current.readyState === WebSocket.CLOSED) {
//             connectWebSocket();
//         }
//         if (connectionStatus === "Inactive") {
//             sendToServer("Active");
//             setConnectionStatus("Active");
//         }
//         resetInactivityTimer();
//     }, [connectionStatus, connectWebSocket, sendToServer, resetInactivityTimer]);

//     const handleLogout = useCallback(() => {
//         sendToServer("Inactive");
//         if (socketRef.current) {
//             socketRef.current.close();
//             console.log("WebSocket closed due to logout");
//         }
//         onLogout?.(); 
//     }, [sendToServer, onLogout]);

//     useEffect(() => {
//         requestNotificationPermission();
//         connectWebSocket();

//         const events = ["mousemove", "keydown", "mousedown", "touchstart"];
//         events.forEach((evt) => document.addEventListener(evt, handleActivity));

//         const handleBeforeUnload = () => {
//             sendToServer("Inactive");
//             if (socketRef.current) {
//                 socketRef.current.close();
//             }
//         };

//         window.addEventListener("beforeunload", handleBeforeUnload);

//         return () => {
//             clearTimeout(inactivityTimerRef.current);
//             events.forEach((evt) => document.removeEventListener(evt, handleActivity));
//             window.removeEventListener("beforeunload", handleBeforeUnload);
//         };
//     }, [handleActivity, requestNotificationPermission, connectWebSocket, sendToServer]);

//     return (
//         <>
//             <Homepage 
//                 userDetails={userDetails} 
//                 accessToken={accessToken} 
//                 connectionStatus={connectionStatus}
//                 selectedLeadId={selectedLeadId} 
//                 onLogout={handleLogout}
//             />
//             <FloatingNote userDetails={userDetails} accessToken={accessToken} />
//         </>
//     );
// };

// export default MainDashBoard;
// changes after the statusthings

import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useLocation } from "react-router-dom";
import Homepage from './Homepage';
import FloatingNote from './Floatingnote';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const MainDashBoard = ({ userDetails, onLogout }) => {
    const socketRef = useRef(null);
    const inactivityTimerRef = useRef(null);
    const lastStatusRef = useRef(null);
    const INACTIVITY_LIMIT = 60000;
    const [connectionStatus, setConnectionStatus] = useState("Inactive");
    const [permissionRequested, setPermissionRequested] = useState(false);
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [userStatus, setUserStatus] = useState(() => {
        return localStorage.getItem('userStatus') || 'Available';
    });
    const userId = userDetails?.userId || userDetails?.id || 'unknown';
    const userFirstName = userDetails?.firstName || 'Unknown';
    const query = useQuery();
    const accessToken = localStorage.getItem('accessToken');

    useEffect(() => {
        localStorage.setItem('userStatus', userStatus);
    }, [userStatus]);

    // Listen for storage changes (in case changed in another tab)
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'userStatus' && e.newValue !== userStatus) {
                setUserStatus(e.newValue || 'Available');
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [userStatus]);

    useEffect(() => {
    const leadId = query.get('leadId');
    const callNumber = query.get('call');

    if (leadId) {
        setSelectedLeadId(leadId);
        console.log("✅ Lead ID set from notification:", leadId);
    }

    if (callNumber) {
        console.log("📞 Initiating call to:", callNumber);
        window.location.href = `tel:${callNumber}`;
    }
    }, [query]);

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', (event) => {
            console.log("📩 Message from service worker:", event.data);
            const { action, leadId, phoneNumber, tag } = event.data; // Added tag for closing notification

            if (leadId) {
                setSelectedLeadId(leadId);
                console.log("✅ Lead ID set from service worker message:", leadId);
            }

            if (action === 'open-lead-call' && phoneNumber) {
                console.log("📞 Initiating call from service worker message:", phoneNumber);
                window.location.href = `tel:${phoneNumber}`;
                // Close the original notification after action
                if (navigator.serviceWorker.controller) {
                    navigator.serviceWorker.controller.postMessage({
                        type: 'closeNotification',
                        tag: tag
                    });
                }
            }

            if (action === 'copy-phone' && phoneNumber) {
                navigator.clipboard.writeText(phoneNumber).then(() => {
                    console.log('Phone number copied to clipboard');
                    // Close the original notification after action (removes the button)
                    if (navigator.serviceWorker.controller) {
                        navigator.serviceWorker.controller.postMessage({
                            type: 'closeNotification',
                            tag: tag
                        });
                    }
                }).catch(err => {
                    console.error('Failed to copy phone number:', err);
                    // Optionally handle error feedback here, e.g., a brief UI toast if available
                });
            }
            });
        }
        }, []);

    const requestNotificationPermission = useCallback(() => {
        if (!("Notification" in window)) {
            console.warn("This browser does not support desktop notifications.");
            return false;
        }
        console.log("Current Notification permission:", Notification.permission);
        if (Notification.permission !== "granted" && Notification.permission !== "denied") {
            Notification.requestPermission().then(permission => {
                console.log("Notification permission result:", permission);
                if (permission === "granted") {
                    console.log("Notification permission granted.");
                    new Notification("Permission Granted", { body: "Notifications are now enabled!" });
                } else {
                    console.warn("Notification permission denied.");
                }
                setPermissionRequested(true);
            });
            return true;
        }
        return Notification.permission === "granted";
    }, []);

    const showNotification = useCallback((title, data, useAlternateIcon = false) => {
        if (Notification.permission === "granted") {
            navigator.serviceWorker.getRegistration().then(registration => {
                if (registration) {
                    const phoneNumber = data.phoneNumber || 'N/A';
                    const body = data.customerName 
                        ? `Customer: ${data.customerName}\nACVL Lead ID: ${data.LeadACVLRecordID || 'N/A'}\nLead Source: ${data.leadSource || 'N/A'}\nMove Date: ${data.moveDate || 'N/A'}\n\nClick notification to open lead`
                        : JSON.stringify(data, null, 2);

                    const iconUrl = useAlternateIcon 
                        ? 'https://cdn-icons-png.flaticon.com/512/5995/5995339.png'
                        : 'https://thumbs.dreamstime.com/z/phone-call-icon-white-phone-call-icon-green-background-100048734.jpg?ct=jpeg';

                    const allActions = [
                        { action: 'copy-phone', title: 'Copy Ph.No' },
                        { action: 'open-lead-call', title: 'Lead&Call' }
                    ];

                    // Dynamically limit actions based on browser support
                    let displayActions = allActions;
                    if ('maxActions' in Notification) {
                        const max = Notification.maxActions;
                        console.log(`Browser supports max ${max} notification actions`);
                        displayActions = allActions.slice(0, max);
                    } else {
                        // Fallback for older browsers, limit to 2 (but we have only 2)
                        displayActions = allActions.slice(0, 2);
                        console.log('Using fallback: max 2 notification actions');
                    }

                    const notificationTag = `message-${Date.now()}`;

                    registration.showNotification(title, {
                        body,
                        icon: iconUrl,
                        requireInteraction: true,
                        tag: notificationTag,
                        actions: displayActions,
                        data: {
                            LeadACVLRecordID: data.LeadACVLRecordID,
                            phoneNumber
                        }
                    });

                    // Note: Pass this tag to service worker if needed for other handling
                } else {
                    console.warn("No service worker registration found.");
                }
            });
        } else {
            console.warn("Cannot show notification: Permission not granted.");
            alert("Notifications are not enabled. Please allow notifications in your browser settings.");
        }
    }, []);

    const sendToServer = useCallback((Userstatus) => {
        const payload = JSON.stringify({
            userId,
            UserFirstName: userFirstName,
            Userstatus,
            accessToken,
            timestamp: new Date().toISOString(),
        });
        if (socketRef.current?.readyState === WebSocket.OPEN) {
            socketRef.current.send(payload);
            console.log(`Sent ${Userstatus} status to server`);
        }
    }, [userId, accessToken, userFirstName]);

    const resetInactivityTimer = useCallback(() => {
        if (userStatus !== 'Available') {
            clearTimeout(inactivityTimerRef.current);
            return;
        }
        clearTimeout(inactivityTimerRef.current);
        inactivityTimerRef.current = setTimeout(() => {
            console.log("User inactive. Sending Inactive status...");
            sendToServer("Inactive");
            setConnectionStatus("Inactive");
        }, INACTIVITY_LIMIT);
    }, [sendToServer, userStatus]);

    const connectWebSocket = useCallback(() => {
        if (socketRef.current && socketRef.current.readyState !== WebSocket.CLOSED) return;
        socketRef.current = new WebSocket(`ws://localhost:8080?userId=${userId}&application=salesjet`);

        socketRef.current.onopen = () => {
            console.log("WebSocket connected");
            const statusToSend = userStatus === 'Available' ? "Active" : "Inactive in break";
            sendToServer(statusToSend);
            setConnectionStatus(statusToSend);
            if (userStatus === 'Available') {
                resetInactivityTimer();
            }
        };

        socketRef.current.onmessage = (event) => {
            try {
                const message = event.data;
                if (message.includes("Data received:")) {
                    console.log("Processing 'Data received' message");
                    const dataStr = message.split("Data received: ")[1];
                    const data = JSON.parse(dataStr);
                    showNotification(`New Lead Notification for ${userId}`, data);
                } else if (message.includes("You sent to")) {
                    console.log("Processing 'You sent' message");
                    const sentMessage = JSON.parse(message.split("You sent -> ")[1]);
                    const status = sentMessage.Userstatus;
                    if (status && lastStatusRef.current !== status) {
                        lastStatusRef.current = status;
                    }
                } else {
                    // console.log("General message:", message);
                }
            } catch (error) {
                console.error("Error parsing server message:", error);
            }
        };

        socketRef.current.onclose = () => {
            console.log("WebSocket disconnected, attempting to reconnect...");
            setConnectionStatus("Inactive");
            setTimeout(connectWebSocket, 5000); 
        };

        socketRef.current.onerror = (err) => {
            console.error("WebSocket error:", err);
            setConnectionStatus("Inactive");
        };
    }, [userId, userStatus, sendToServer, resetInactivityTimer, showNotification]);

    // Handle status change: send appropriate status to server
    useEffect(() => {
        const statusToSend = userStatus === 'Available' ? 'Active' : 'Inactive in break';
        sendToServer(statusToSend);
        setConnectionStatus(statusToSend);
        if (userStatus === 'Available') {
            resetInactivityTimer();
        } else {
            clearTimeout(inactivityTimerRef.current);
        }
    }, [userStatus, sendToServer, resetInactivityTimer]);

    const handleActivity = useCallback(() => {
        if (userStatus !== 'Available') return; // Only handle activity if Available

        if (!socketRef.current || socketRef.current.readyState === WebSocket.CLOSED) {
            connectWebSocket();
        }
        if (connectionStatus === "Inactive") {
            sendToServer("Active");
            setConnectionStatus("Active");
        }
        resetInactivityTimer();
    }, [connectionStatus, connectWebSocket, sendToServer, resetInactivityTimer, userStatus]);

    const handleLogout = useCallback(() => {
        sendToServer("Inactive");
        if (socketRef.current) {
            socketRef.current.close();
            console.log("WebSocket closed due to logout");
        }
        onLogout?.(); 
    }, [sendToServer, onLogout]);

    useEffect(() => {
        requestNotificationPermission();
        connectWebSocket();

        const events = ["mousemove", "keydown", "mousedown", "touchstart"];
        events.forEach((evt) => document.addEventListener(evt, handleActivity));

        const handleBeforeUnload = () => {
            sendToServer("Inactive");
            if (socketRef.current) {
                socketRef.current.close();
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            clearTimeout(inactivityTimerRef.current);
            events.forEach((evt) => document.removeEventListener(evt, handleActivity));
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [handleActivity, requestNotificationPermission, connectWebSocket, sendToServer]);

    return (
        <>
            <Homepage 
                userDetails={userDetails} 
                accessToken={accessToken} 
                connectionStatus={connectionStatus}
                selectedLeadId={selectedLeadId} 
                userStatus={userStatus}
                setUserStatus={setUserStatus}
                onLogout={handleLogout}
            />
            <FloatingNote userDetails={userDetails} accessToken={accessToken} />
        </>
    );
};

export default MainDashBoard;